import { render, staticRenderFns } from "./RenderQuestion.vue?vue&type=template&id=acc39f56&scoped=true"
import script from "./RenderQuestion.vue?vue&type=script&lang=js"
export * from "./RenderQuestion.vue?vue&type=script&lang=js"
import style0 from "./RenderQuestion.vue?vue&type=style&index=0&id=acc39f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc39f56",
  null
  
)

export default component.exports